//
// Copyright 2023 DXOS.org
//

export const stepStyles = 'pbs-1 pbe-3 pli-3';
